/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { TESTIMONIALS_CARD_WIDTH } from 'bundles/front-page/common/constants';
import Slider from 'bundles/front-page/components/modules/slider/Slider';

type Props = {
  testimonialItems: React.ReactNode[];
};

const styles = {
  sliderWrapper: css`
    padding-top: var(--cds-spacing-200);

    // Targets wrapper for slide indicators (dots) and nav arrows
    > div > div:last-of-type {
      margin: var(--cds-spacing-100) var(--cds-spacing-100) 0;
      width: 95%;

      // Dots container
      > div:first-of-type {
        width: 30%;

        // Update styling of active dot
        div[data-testid*='-active'] {
          width: inherit;
          border-radius: inherit;
        }
      }
    }
  `,

  streamlinedXDPTestimonial: css`
    height: 100%; // Makes all testimonial cards the same height

    // Targets inner most wrapper of a card
    > div {
      padding: var(--cds-spacing-200);
      margin: 0 var(--cds-spacing-50);
      text-wrap: auto;

      // Learner image/name container
      > div:first-of-type {
        margin-bottom: var(--cds-spacing-150);

        img {
          border: 1px solid var(--cds-color-neutral-background-primary-weak);
          box-shadow: 0 2px 4px 0 rgb(0 0 0 / 15%);
          max-height: 80px !important;
          max-width: 80px !important;
        }
      }
    }
  `,
};

const TestimonialSlider = ({ testimonialItems }: Props) => {
  if (!testimonialItems?.length) {
    return null;
  }

  return (
    <div css={styles.sliderWrapper}>
      <Slider forcedCardWidth={TESTIMONIALS_CARD_WIDTH}>
        {testimonialItems?.map((testimonial, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={index} css={styles.streamlinedXDPTestimonial}>
            {React.cloneElement(testimonial as React.ReactElement)}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialSlider;
